/**
 * Created by diegocanales on 10/28/17.
 */
import { Loader } from './Loader'
export default Loader
